export { ColumnRatioOption } from './ColumnRatioOption';
export { TwoColumns } from './TwoColumns';

export type { TwoColumnsProps, TwoColumnsRatio } from './TwoColumns';
